import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=35491106&scoped=true"
import script from "./EditorDialog.vue?vue&type=script&lang=js"
export * from "./EditorDialog.vue?vue&type=script&lang=js"
import style0 from "./EditorDialog.vue?vue&type=style&index=0&id=35491106&prod&lang=css"
import style1 from "./EditorDialog.vue?vue&type=style&index=1&id=35491106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35491106",
  null
  
)

export default component.exports